// material-ui
import {styled} from '@mui/material/styles';
import LinearProgress, {LinearProgressProps} from '@mui/material/LinearProgress';
import {ApplinearLoader} from 'components/loaders';

// loader style
const LoaderWrapper = styled('div')(({theme}) => ({
    position: 'fixed',
    top: 0,
    left: 0,
    zIndex: 2001,
    width: '100%',
    '& > * + *': {marginTop: theme.spacing(2)},
}));

// ==============================|| Loader ||============================== //

export interface LoaderProps extends LinearProgressProps {}

export const Loader = () => {
    return (
        <LoaderWrapper>
            <ApplinearLoader />
        </LoaderWrapper>
    );
};

export default Loader;
